module.exports = __webpack_public_path__ + "static/img/introduction_video_bg.0758e2c0.png";